/* Works on initial load and after Shopify theme-editor section replacement. */
(() => {
  if (window.tlwkLoaded) return;
  window.tlwkLoaded = true;
  const openEnquiry = (packageName, focus = false) => {
    const enquiry = document.getElementById('tlwk-enquiry');
    if (!enquiry) return;
    enquiry.open = true;
    const input = enquiry.querySelector('[data-tlwk-package-input]');
    if (input && packageName) input.value = packageName;
    if (focus) requestAnimationFrame(() => enquiry.querySelector('input')?.focus({ preventScroll: true }));
  };
  const syncState = () => {
    if (location.hash === '#tlwk-enquiry' || document.querySelector('.tlwk-form-success, .tlwk-form-errors')) openEnquiry();
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-tlwk-package], [data-tlwk-enquiry]');
    if (target) openEnquiry(target.dataset.tlwkPackage, true);
    if (event.target.closest('.tlwk-mobile-menu a')) document.querySelectorAll('.tlwk-mobile-menu').forEach(menu => menu.open = false);
    if (!event.target.closest('.tlwk-mobile-menu')) document.querySelectorAll('.tlwk-mobile-menu').forEach(menu => menu.open = false);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.tlwk-mobile-menu[open]').forEach(menu => {menu.open = false; menu.querySelector('summary').focus();});
  });
  document.addEventListener('shopify:section:load', syncState);
  document.addEventListener('shopify:block:select', event => {
    const details = event.target.closest('details');
    if (details) details.open = true;
  });
  window.addEventListener('hashchange', syncState);
  syncState();
})();
